require('./hireCardOpenYoungStep6.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');

//@commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');

// @components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const HireOpenYoungSummary = require('components/hire/hireOpenYoungSummary/hireOpenYoungSummary');
const WebappRender = require('components/conditionalRender/webappRender')

// @constants
const {
    ADD_NEW_SHIPPING_ADDRESS,
    CARD_OPEN_YOUNG_CREDIT_OPERATION_CODE,
    CARD_OPEN_YOUNG_OPERATION_CODE,
    MULTIPLE_OPERATIONS,
    messages: { HIRE_CARD_OPEN_YOUNG },
} = require('constants/operationTypes');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const {
        OPENYOUNG_CARD_STANDARD,
        OPENYOUNG_CARD_SUBTYPE,
        OPENYOUNG_CARD_TYPE,
        SIXTH_STEP,
    } = require('constants/index');
const { OPEN_YOUNG_CARD_PRODUCT_NAME } = require('constants/cardsPrecontractualMailInfo');

class HireCardOpenYoungStep6 extends React.Component {
    componentDidMount() {
        const { sendPrecontractualDocumentMail } = this.props;
        const precontractualMailProductInfo = {
            productName: OPEN_YOUNG_CARD_PRODUCT_NAME,
            producto: OPENYOUNG_CARD_TYPE,
            standard: OPENYOUNG_CARD_STANDARD,
            subproducto: OPENYOUNG_CARD_SUBTYPE
        };
        sendPrecontractualDocumentMail(precontractualMailProductInfo);

        if (!__CONTACT_CENTER__) {
            //This action is also called in the first step of the current hiring, if you update one remeber that maybe you should update the other one
            this.props.setTermsAndCondsText('hireCardOpenYoung-hireCardOpenYoung_confirmationStepAgreementText');
        }
    }

    buildAsociatedAccount() {
        const {
            immAccounts,
            selectedAccount,
        } = this.props;

        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const accountIban = getLastNChars(immAccount.get('iban'));
        return (
            <div>
                {immAccount.get('alias')}
                &nbsp;
                {accountIban}
            </div>
        );
    }

    render() {
        const {
            handleAgreementCheckboxChange,
            immShippingAddress,
            immHireCardOpenYoung,
            immOpenYoungPersonalData,
            immPdfData
        } = this.props;

        const immStep6 = immHireCardOpenYoung.getIn(['steps', SIXTH_STEP]);
        const agreementLabel = <FormattedText value="hireCardOpenYoung-hireCardOpenYoung_confirmationStepAgreementText" />;
        const agreementChecked = immStep6.get('agreementChecked');
        const agreementErrorVisible = immStep6.get('agreementIsDirty') && !immStep6.get('agreementChecked');
        const agreementErrorMsg = formatText('hireCardOpenYoung-hireCardOpenYoung_step5CheckboxErrorMsg');
        const pdfError = immPdfData.get('errorContent');
        const minorName = immOpenYoungPersonalData.getIn(['name', 'value']);
        const minorLastName = immOpenYoungPersonalData.getIn(['lastName', 'value']);
        const minorLastName2 = immOpenYoungPersonalData.getIn(['lastName2', 'value']);
        const minorFullName = `${minorName} ${minorLastName} ${minorLastName2}`;
        const asociatedAccount = this.buildAsociatedAccount();
        const shippingAddress = PersonalDataHelper.getHireFormattedAddress(immShippingAddress);
        const operationParams = {
            id: HIRE_CARD_OPEN_YOUNG,
            requestMulti: [{
                serviceCode: CARD_OPEN_YOUNG_OPERATION_CODE,
            },
            {
                serviceCode: CARD_OPEN_YOUNG_CREDIT_OPERATION_CODE,
            },
            {
                serviceCode: ADD_NEW_SHIPPING_ADDRESS
            }]
        };

        const preContractDocumentInfo = getCardsPreContractPdfData()['open_young_card'];
        let agreementCheckboxContent, GDPRSignaturePatternContent;

        if(!pdfError) {
            agreementCheckboxContent = (
                <div className="hire-card-open-young-step-six__checkbox-container">
                    <WebappRender>
                        <OKCheckbox
                            idName="hireCardOpenYoungAgreementCheckbox"
                            errorMessage={agreementErrorMsg}
                            errorState={agreementErrorVisible}
                            label={agreementLabel}
                            onChange={handleAgreementCheckboxChange}
                            value={agreementChecked}
                        />
                    </WebappRender>
                </div>
            )
        }

        if(agreementChecked) {
            GDPRSignaturePatternContent = (
                <SignaturePattern
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={operationParams}
                />
            )
        }

        return (
            <article className="hire-card-open-young-step-six">
                <FormattedText
                    className="hire-card-open-young__step-title print-title"
                    value="hireCardOpenYoung-hireCardOpenYoung_step5Title"
                />
                <FormattedText
                    className="hire-card-open-young-step-six__subtitle"
                    value="hireCardOpenYoung-hireCardOpenYoung_step5Subtitle"
                />
                <HireOpenYoungSummary
                    asociatedAccount={asociatedAccount}
                    name={minorFullName}
                    shippingAddress={shippingAddress}
                />
                <WebappRender>
                    <div className="hire-pack-open-young-step-five__pdf-viewer-container">
                        <PreContractualDocumentViewer
                            preContractDocumentInfo={preContractDocumentInfo}
                            titleKey="preContractDocument_pdfTitleOpenYoung"
                        />
                    </div>
                </WebappRender>
                {agreementCheckboxContent}
                {GDPRSignaturePatternContent}
            </article>
        );
    }
}

HireCardOpenYoungStep6.propTypes = {
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireCardOpenYoung: PropTypes.object.isRequired,
    immOpenYoungPersonalData: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immShippingAddress: PropTypes.object.isRequired,
    selectedAccount: PropTypes.string.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
};

module.exports = HireCardOpenYoungStep6;
